import React from 'react';
import DashBoardNavBar from '../components/DashBoardNavBar.tsx';
import AdminUserManagement from "../components/AdminUserManagement.tsx";

const Admin: React.FC = () => {
  return (
    <>
      <DashBoardNavBar />
      <AdminUserManagement />
      <div></div>
    </>
  );
};

export default Admin;
